export const TASKS_START = 'TASKS_START';
export const TASKS_SUCCESS = 'TASKS_SUCCESS';
export const TASKS_FAILURE = 'TASKS_FAILURE';
export const TASKS_RESET = 'TASKS_RESET';

export const GET_TASK = 'GET_TASK';
export const SUBMIT_TASK = 'SUBMIT_TASK';

export const GRADE_TASK = 'GRADE_TASK';
export const MENTOR_SUBMISSIONS = 'MENTOR_SUBMISSIONS';
export const GET_MENTEE_TASK_SUBMISSION = 'GET_MENTEE_TASK_SUBMISSION';
export const GET_MENTEE_TASK_SUBMISSION_SUCCESS =
  'GET_MENTEE_TASK_SUBMISSION_SUCCESS';
export const GET_MENTEE_TASK_SUBMISSION_FAILURE =
  'GET_MENTEE_TASK_SUBMISSION_FAILURE';
export const MENTEE_SUBMITTED_TASKS_SUCCESS = 'MENTEE_SUBMITTED_TASKS_SUCCESS';
